import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFile = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 20 20",
	fill: "none",
	width: "1em",
	height: "1em",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M17.5 9.16016V8.32682C17.5 5.18432 17.5 3.61266 16.4667 2.63682C15.4325 1.66016 13.7683 1.66016 10.4417 1.66016H9.55833C6.2325 1.66016 4.56833 1.66016 3.53333 2.63682C2.5 3.61266 2.5 5.18432 2.5 8.32682V11.6602C2.5 14.8027 2.5 16.3743 3.53333 17.3502C4.5675 18.3268 6.23167 18.3268 9.55833 18.3268H10M6.66667 5.82682H13.3333M6.66667 9.99349H10.8333",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M17.5 17.1993V14.1602C17.5 12.9685 16.3808 11.6602 15 11.6602C13.6192 11.6602 12.5 12.9685 12.5 14.1602V17.0768C12.5 17.7268 13.1108 18.3268 13.8633 18.3268C14.6167 18.3268 15.2275 17.7268 15.2275 17.0768V14.7977",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgFile;
